<template>
  <div class="wrapper-page">
    <div id="pano"></div>
    <div class="menu-list" id="menuItems">
      <span class="menu-item" v-for="(menu, index) in menus" :key="index" @click="menuBtnClick(menu)">{{menu.name}}</span>
    </div>
    <div class="amount-msg" v-if="currentLand && currentLand.areaLevel == 3">
      <p>剩余数量：{{getLeftNum}}</p>
      <p>总共数量：{{getTotalNum}}</p>
    </div>
    <div class="land-detail" v-if="selectedLand">
      <p>地块名称：{{selectedLand.areaName}}</p>
      <p>地块详情：{{selectedLand.plotSize || 0}}m²</p>
      <template v-if="selectedLand.buyTime">
        <p>认购日期：{{selectedLand.buyTime || ''}}</p>
        <p>到期日期：{{selectedLand.endTime || ''}}</p>
      </template>
      <template v-else>
        <p>有效期年限：{{selectedLand.effectYear || '-'}}年</p>
        <span class="purchase-btn" @click="toPurchaseDetail" v-if="!selectedLand.userId">去认购</span>
      </template>
    </div>
    <div class="back-btn" @click="toHigherLand" v-if="currentLand && currentLand.areaLevel > 1">
    </div>
    <div class="land-list">
      <div class="land-item" @click="toLowerLand(item)"
        v-for="(item, index) in landList" :key="index">
        <img :src="item.areaImg || placeholderImg | filterPrefix" class="land-item-image" />
        <div class="land-item-name">{{item.areaName}}</div>
      </div>
    </div>
  </div>
</template>
<script>
var self = null
import { MImage } from 'mcanvas'
const oldPrefix = 'http://193.112.137.199:8002', newPrefix = 'https://vr.gdyfpt.com'
export default {
  data() {
    return {
        // 当前用户id
        userId: '',
        // vrId
        vrId: '',
        //  vr数据
        vrData: null,
        // 接口返回scene list
        vrSceneList: [],

        // 当前地块的下级地块，土地列表
        landList: [],
        // 当前地块
        currentLand: null,
        // 选中地块
        selectedLand: null,
        // 当前选择的下级地块
        currLowerLand: null,
        // 存储历史上级地块
        historyLand: [],

        // 其他菜单
        menus: [
          {
						name: '我要认购',
						url: '/farmPages/farm/purchaseLand',
						action: 'navigateTo'
					},
					{
						name: '订餐',
						url: '/orderingPages/index',
						action: 'navigateTo'
					},
					{
						name: '订房',
						url: '/bookingPages/index',
						action: 'navigateTo'
					},
					{
						name: '购物',
						url: '/shopPages/shop/tabbar',
						action: 'navigateTo'
					},
					{
						name: '实时视频',
						url: '/farmPages/farm/monitor',
						action: 'navigateTo'
					}
        ],

        //krpano对象
        krpano: document.querySelector('#krpanoSWFObject'),
        //场景列表
        sceneList: [],
        //当前场景序号
        currentSceneIndex: -1,
        // 当前场景
        currentScene: null,
        //欢迎页场景序号
        welcomeSceneIndex: -1,
        //接口请求状态
        requesting: false,
        // 土地占位图
        placeholderImg: 'https://vr.gdyfpt.com/file/pic/20201026181417209173.png'
      }
  },
  created() {
    // console.log('created', this.$route)
    self = this
    window.onresize = () => {
      this.getRem(7.5);
    }
    if(this.$route.query.vrId) {
      this.vrId = this.$route.query.vrId
    }
    if(this.$route.query.userId) {
      this.userId = this.$route.query.userId
    }
  },
  computed: {
    getLeftNum() {
      var arr = this.landList.filter(item => {
        return !item.userId
      })
      return arr.length
    },
    getTotalNum() {
      return this.landList.length
    }
  },
  mounted() {
    this.getRem(7.5);
    embedpano({
      // 该文件仅用于Flashplayer，而仅使用HTML5时，则不需要此文件。
      swf: "/static/tour.swf",
      xml: "/static/tour2.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      // 布尔设置。设置为true时，来自html url的所有查询参数将作为变量传递给查看器。
      passQueryParameters: true,
      onready: this.onready
    });
    
    // 侦听场景切换
    window['onnewscene'] = (val) => {
      self.onnewscene(val)
    }
  },
  filters: {
    filterPrefix(imageStr) {
      if(typeof imageStr === 'string') {
        return imageStr.replace(oldPrefix, newPrefix)
      }
      return imageStr
    }
  },
  watch: {
    // selectedLand: {
    //   handler(n, o) {
    //     console.log('selectedLand', n)
    //   },
    //   deep: true
    // }
  },
  methods: {
    menuBtnClick(item) {
      console.log('item', item)
      var currentLand = this.currentLand
      
      var action = item.action
      var url = item.url
      if(url.indexOf('purchaseLand') !== -1 && currentLand) {
        var hasParams = url.indexOf('?') !== -1
        url += (hasParams ? '&' : '?') + 'areaLevel=' + currentLand.areaLevel + '&areaId=' + currentLand.id + '&parentId=' + currentLand.parentId
      }
      switch (action) {
        case 'switchTab':
          uni.switchTab({
            url: url
          });
          break;
        case 'reLaunch':
          uni.reLaunch({
            url: url
          });
          break;
        case 'navigateBack':
          uni.navigateBack({
            delta: 1
          });
          break;
        default:
          uni[action]({
            url: url
          });
          break;
      }
    },
    getRem(prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = oWidth / prem + "px";
    },
    //入口js文件已将此函数定义到window，krpano加载完成后调用
    onready() {
      console.log('myready')
      this.krpano = document.querySelector('#krpanoSWFObject')
      
      //初始化场景
      this.sceneList = this.krpano.get('scene').getArray()
      

      //热点移动事件初始化
      let thisVue = this
      let pano = document.querySelector('#pano')
      
      if(this.vrId) {
        this.getVrByLand({
          vrId: this.vrId
        }, true)
      } else {
        this.getManorDetails() 
        this.getSubscription()
      }
    },
    // 跳转到购买地块页面
    toPurchaseDetail() {
      uni.navigateTo({
        url: '/farmPages/farm/purchaseDetail?id=' + this.selectedLand.parentId + '&child=' + this.selectedLand.id
      });
    },
    // 加载全部场景
    addAllScene(list) {
      if(!list) return
      list.forEach((item, index) => {
        var imageXmlStr = ''
        var previewXmlStr = item.previewurl ? `<preview url="${item.previewurl}"/>` : ''
        if(item.imageType == 1) {
          imageXmlStr = `
          <image>
              <sphere url="${item.imageurl}" />
          </image>`
        } else if(item.imageType == 2) {
          var images = item.images ? item.images : []
          var prefix = ''
          if(images.length > 0) {
            prefix = images[0].imageurl.split('_')[0]
          }
          imageXmlStr = `
          <image type="CUBE">
            <cube url="${prefix + '_%s.jpg'}"/>
          </image>`
        }
        this.krpano.call('addscene(' + item.name + ');')
        // 场景的title即为热点title文字，或热点的text
        this.krpano.set('scene[' + item.name + '].title', item.name)
        this.krpano.set('scene[' + item.name + '].imageurl', item.imageurl)
        this.krpano.set('scene[' + item.name + '].thumburl', item.thumburl)
        this.krpano.set('scene[' + item.name + '].images', images)
        this.krpano.set('scene[' + item.name + '].imagetype', item.imageType)
        // this.krpano.set('scene[' + item.name + '].welcomeFlag', item.welcomeFlag)
        this.krpano.set('scene[' + item.name + '].content', 
          `
          <view hlookat="${item.initH || 0}" vlookat="${item.initV || 0}" fovtype="MFOV" fov="${item.fov}" fovmin="${item.fovmin}" fovmax="${item.fovmax}" limitview="auto"/>
          ` + previewXmlStr + imageXmlStr + `
          <autorotate enabled="${item.autorotate ? item.autorotate.enabled || false : false}" waittime="${item.autorotate ? item.autorotate.waitTime : 0}" accel="1.0" speed="5.0" horizon="0.0"/>
          `
        );
        // addhotspot只在有场景时生效
      })
      
      // 同步数据到sceneList
      for(let x in this.sceneList) {
        var sceneData = list[x]
        if(sceneData) {
          // this.sceneList[x] = Object.assign(sceneData, this.sceneList[x])
          for(let column in sceneData) {
            if(!this.sceneList[x].hasOwnProperty(column)) {
              this.sceneList[x][column] = sceneData[column]
            }
          }
        }
      }

      // 加载初始化场景
      if(this.currentSceneIndex == -1 && this.sceneList) {
        var startIndex = this.sceneList.findIndex(item => {
          return item.welcomeFlag === 'true' || item.welcomeFlag === true
        })
        if(startIndex !== -1) {
          this.welcomeSceneIndex = startIndex
          this.changeScene(this.sceneList[startIndex], true)
        } else if(this.sceneList.length > 0) {
          // 没有设置初始场景，显示第一个
          this.changeScene(this.sceneList[0], true)
        }
      }
      // console.log('list', this.sceneList)
      
    },
    // 清除所有场景
    removeAllScene() {
      
      var sceneNames = this.krpano.get('scene').getArray().map((scene) => {
        return scene.name
      })
      // console.log('remove', sceneNames)
      // console.log(this.sceneList, this.sceneList.length)
      sceneNames.forEach(name => {
        this.krpano.set('scene[' + name + '].name', null)
      })
      // console.log(this.sceneList, this.sceneList.length)
      this.vrData = null
      
      this.vrSceneList = []
      this.currentSceneIndex = -1
      this.welcomeSceneIndex = -1
      // this.krpano.call('loadscene(二级地2)', null, 'REMOVESCENES');
    },
    // 侦听场景切换
    onnewscene(sceneName) {
      // console.log('onnewscene', sceneName)
      if(this.currentScene.name != sceneName) {
        this.currentScene = this.sceneList.find(scene => {
          return scene.name == sceneName
        })
        this.currentSceneIndex = this.currentScene ? this.currentScene.index : -1
      }
      this.initHotSpot()
    },
    //根据krpano参数初始化视角和热点模块数据
    initView() {
      //初始化视角参数
      this.autoSpinWaitingTime = this.krpano.get('autorotate.waittime')
      this.autoSpinFlag = this.krpano.get('autorotate.enabled')
      this.minFov = this.krpano.get('view.fovmin')
      this.maxFov = this.krpano.get('view.fovmax')
      this.initFov = this.krpano.get('view.fov')
    },
    //热点初始化
    initHotSpot() {
      // adddhotspot之后热点并不会自动添加到场景中的hotspots中去，手动添加
      // hotspot的keep默认为false，切换场景后自动消失
      if(this.currentScene) {
        // 添加热点
        var hotSpots = this.currentScene.hotspots || this.currentScene.hotSpots
        if(hotSpots) {
          hotSpots.forEach(hotSpot => {
            var linkedscene = hotSpot.linkedscene
            this.krpano.call('addhotspot(' + hotSpot.name + ');')
            this.krpano.get('hotspot[' + hotSpot.name + ']').loadstyle(hotSpot.style)
            this.krpano.set('hotspot[' + hotSpot.name + '].ath', hotSpot.ath)
            this.krpano.set('hotspot[' + hotSpot.name + '].atv', hotSpot.atv)
            this.krpano.set('hotspot[' + hotSpot.name + '].linkedscene', linkedscene)
            this.krpano.set('hotspot[' + hotSpot.name + '].dive', hotSpot.dive)

            this.krpano.set('hotspot[' + hotSpot.name + '].bindvrid', hotSpot.bindVrId || hotSpot.bindvrid)
            this.krpano.set('hotspot[' + hotSpot.name + '].areaid', hotSpot.areaId || hotSpot.areaid)
            this.krpano.set('hotspot[' + hotSpot.name + '].hotspottype', hotSpot.hotspottype)
            this.krpano.set('hotspot[' + hotSpot.name + '].areaname', hotSpot.areaName || hotSpot.areaname)
            this.krpano.set('hotspot[' + hotSpot.name + '].text', hotSpot.areaName || hotSpot.areaname)
            if(this.currentLand && this.currentLand.areaLevel == 3 && hotSpot.hotspottype == 2 && (hotSpot.areaid || hotSpot.areaId)) {
              var text = '可认购'
              var areaId = hotSpot.areaid || hotSpot.areaId
              var land = this.landList.find(item => {
                return item.id == areaId
              })
              // console.log('landList', this.landList)
              if(land && land.userId) {
                text = '已认购'
                // var mi = new MImage(newPrefix + '/file/pic/20201027171519278479.jpg')
                var mi = new MImage(land.userImg)
                mi.crop({
                    x: 'center',
                    y: 'center',
                    radius: '50%',
                })
                mi.draw({
                  type: 'png',
                  success(b64) {
                    // console.log(b64)
                    self.krpano.set('hotspot[' + hotSpot.name + '].url', b64)
                  }
                })
                this.krpano.get('hotspot[' + hotSpot.name + ']').loadstyle('skin_hotspotstyle_tooltip')
                
                this.krpano.set('hotspot[' + hotSpot.name + '].width', '100')
                this.krpano.set('hotspot[' + hotSpot.name + '].height', '100')
              }
              this.krpano.set('hotspot[' + hotSpot.name + '].text', text)
            }
          })
        }
        if(this.sceneList[this.currentSceneIndex]) {
          this.sceneList[this.currentSceneIndex].hotspots = []
        }
        this.krpano.get('hotspot').getArray().forEach((hotspot) => {
          if (hotspot.name != 'webvr_prev_scene' && hotspot.name != 'webvr_next_scene' && hotspot.name != 'vr_cursor') {
            // console.log(this.currentSceneIndex, this.sceneList.length, this.sceneList)
            if(this.sceneList[this.currentSceneIndex]) {
              this.sceneList[this.currentSceneIndex].hotspots.push(hotspot)
            }
            this.initHotspotEvent(hotspot)
          }
        })
        // console.log(this.sceneList)
      }
    },
    // 通过场景名称获取关联数据
    getSceneDataByName(scene) {
      if(!scene) return null
      if(this.vrSceneList) {
        var sceneItem = this.vrSceneList.find(item => {
          return item.name === scene.name
        })
        return sceneItem
      }
      return null
    },
    //切换操作模块
    changeModule(module) {
      this.module = module
    },
    //切换当前场景
    changeScene(scene, fisheye = false) {
      // console.log('change', scene, this.currentSceneIndex)
      // console.log(this.vrSceneList)
      // console.log(this.sceneList)
      if (this.currentSceneIndex == scene.index) return
      
      this.currentSceneIndex = scene.index
      this.currentScene = this.sceneList[this.currentSceneIndex]
      this.krpano.call('loadscene(' + scene.name + ')');
      let currentScene = this.sceneList[this.currentSceneIndex]
      //加载临时存储数据应用于krpano
      //自动旋转
      if (currentScene.autorotate) {
        this.krpano.set('autorotate.enabled', currentScene.autorotate.enabled)
        this.krpano.set('autorotate.waittime', currentScene.autorotate.waitTime)
      }
      if (this.autoSpinFlag) this.krpano.get('autorotate').interrupt()
      //视角
      // if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH)
      // if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV)
      // if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax)
      // if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin)
      // if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov)

      
      if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin)
      if(fisheye) {
        this.krpano.set('view.fisheye', '1.0')
        this.krpano.set('view.stereographic', true)
        this.krpano.set('view.fovmax', 150)
        this.krpano.set('view.hlookat', currentScene.initH ? (180 + Number(currentScene.initH)) : 180)
        this.krpano.set('view.vlookat', 90)
        this.krpano.set('view.fov', 150)

        this.krpano.call(`setfish(${currentScene.initH}, ${currentScene.initV}, ${currentScene.fov})`)
      } else {
        this.krpano.set('view.fisheye', '0.0')
        this.krpano.set('view.stereographic', false)
        if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax)
        if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH)
        if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV)
        if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov)
      }
      
      //初始化模块数据
      this.initView()
      // this.initHotSpot()
    },
    //热点事件初始化
    initHotspotEvent(hotspot) {
      if(hotspot.hotspottype == 2 && hotspot.areaid) {
        hotspot.onclick = function() {
          var land = self.landList.find(item => {
            return item.id == hotspot.areaid
          })
          if(land) {
            // if(land.areaLevel == 4) {
            //   self.selectedLand = land
            // } else {
              self.toLowerLand(land)
            // }
          }
        }
      }
      // hotspot.onclick = function () {
        
      // }
      // hotspot.onloaded = function () {
        // self.addHotSpotTip()
      // }
    },
    // 获取一级土地详情
    getManorDetails() {
      this.$mobile.getManorDetails(2).then(res => {
        if(res.data && res.data.vrId) {
          self.currentLand = res.data
          self.getVrByLand(self.currentLand)
        }
      })
    },
    // 获取一级下的二级
    getSubscription() {
      this.$mobile.getSubscription().then(res => {
        if(res.success) {
          self.landList = res.data.filter(item => {
            return item.id != -1
          })
        }
      })
    },
    // 获取二级下的三级
    getSubscriptionType(id) {
      this.$mobile.getSubscriptionType({
        id
      }).then(res => {
        if(res.success) {
          self.landList = res.data
        }
      })
    },
    // 获取三级详情，及三级下的四级
    getManorFourArea(id) {
      this.$mobile.getManorFourArea(id).then(res => {
        if(res.success) {
          self.landList = res.data.fourAreaList
          self.initHotSpot()
        } else {
          self.landList = []
        }
      })
    },
    // 根据级别获取土地列表
    getLandListByLevel(level, land) {
      // console.log('get', level, land)
      if(level == 1) {
        
      } else if(level == 2) {
        this.getSubscription()
      } else if(level == 3) {
        this.getSubscriptionType(land.id)
      } else if(level == 4) {
        this.getManorFourArea(land.id)
      } else {
        this.landList = []
      }
    },
    // 前往上级
    toHigherLand() {
      console.log('toHigherLand', this.historyLand)
      if(this.historyLand.length > 0) {
        this.currentLand = this.historyLand.pop()
        this.selectedLand = null
        this.getVrByLand(this.currentLand)
        this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand)
      }
    },
    // 前往下级
    toLowerLand(land) {
      // console.log('toLowerLand', land)
      if(land.areaLevel == 4 && this.userId && land.userId && this.userId != land.userId) {
        this.$message.warning('该地块已被认购')
        return
      }
      this.historyLand.push(this.currentLand)
      this.currentLand = land
      if(land.areaLevel == 4) {
        this.selectedLand = land
      }
      this.getVrByLand(this.currentLand)
      this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand)
    },
    // 通过vrid跳转到对应土地
    toLandByVrId(vrId) {
      var item = this.landList.find(item => {
        return item.vrId === vrId
      })
      if(item) {
        this.currLowerLand = item
        this.toLowerLand()
      }
    },
    // 获取土地关联vr
    getVrByLand(land, changeTitle = false) {
      if(!land.vrId) {
        this.$message.warning('该地块暂无vr')
        return
      }
      this.removeAllScene()
      this.$mobile.showVr(land.vrId).then(res => {
        if(res.success) {
          if(res.data.vr) {
            var vr = res.data.vr
            this.vrData = vr
            this.vrSceneList = vr.vrSceneList
            for(let x in this.vrSceneList) {
              var item = this.vrSceneList[x]
              for(let index in item) {
                if(typeof item[index] == 'string' && item[index].indexOf('http://193.112.137.199:8002') !== -1) {
                  item[index] = item[index].replace(oldPrefix, newPrefix)
                }
              }
              if(item.images) {
                item.images = item.images.map(imageItem => {
                  imageItem.imageurl = imageItem.imageurl.replace(oldPrefix, newPrefix)
                  return imageItem
                })
              }
              this.vrSceneList[x] = item
            }
            console.log('scenelist', this.vrSceneList)
            this.addAllScene(this.vrSceneList)
          }
          if(res.data.fourArea && changeTitle) {
            document.title = res.data.fourArea.areaName
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}
#pano {
  width: 100vw;
  height: 100vh;
}
.back-btn {
  position: fixed;
  width: .44rem;
  height: .44rem;
  background-color: rgba(255, 255, 255, .5);
  border-radius: 50%;
  overflow: hidden;
  left: .2rem;
  bottom: 2.7rem;
  background-image: url(../assets/icon-back.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
.land-list {
  position: fixed;
  left: 0;
  right: 0;
  bottom: .36rem;
  height: 2.12rem;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 .24rem;
  white-space: nowrap;
  // &::-webkit-scrollbar {
  //   display: none;
  // }
  .land-item {
    position: relative;
    width: 2.12rem;
    height: 2.12rem;
    border: .06rem solid #FFCC5B;
    border-radius: .1rem;
    overflow: hidden;
    display: inline-block;
    margin-right: .1rem;
    background-color: #eaeaea;
    .land-item-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: .1rem;
    }
    .land-item-name {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: .4rem;
      line-height: .4rem;
      background-color: rgba(0, 0, 0, .21);

      font-size: .24rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.menu-list {
  position: fixed;
  top: .1rem;
  left: .3rem;
  right: .3rem;
  height: .5rem;
  display: flex;
  justify-content: space-between;
  .menu-item {
    width: 1.3rem;
    height: .5rem;
    line-height: .5rem;
    background: #4D89E6;
    border-radius: .1rem;
    text-align: center;
    font-size: .24rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}
.amount-msg {
  position: fixed;
  top: .8rem;
  right: .3rem;
  width: 1.9rem;
  height: .96rem;
  background-color: rgba(0, 0, 0, .41);

  line-height: .48rem;
  font-size: .24rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  padding-left: .2rem;
  p {
    margin: 0;
    padding: 0;
    white-space: nowrap;
  }
}
.land-detail {
  position: fixed;
  bottom: 2.78rem;
  right: .3rem;
  width: 3rem;
  background-color: rgba(0, 0, 0, .41);

  line-height: .48rem;
  font-size: .24rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  padding-left: .2rem;
  p {
    margin: 0;
    padding: 0;
    white-space: nowrap;
  }
  .purchase-btn {
    // background: gray;
    background: #4caf50;
    color: #fff;
    float: right;
    margin: 0 .4rem .2rem 0;
    border-radius: 6px;
    display: block;
    height: .4rem;
    line-height: .4rem;
    padding: 0 .1rem;
  }
}
</style>


// WEBPACK FOOTER //
// MobileVR.vue?2ebe86b6